/*
cite from:
https://esbuild.github.io/content-types/#real-esm-imports

# Imports follow ECMAScript module behavior

You might try to modify global state before importing a module which needs that global state and expect it to work. However, JavaScript (and therefore esbuild) effectively "hoists" all import statements to the top of the file, so doing this won't work:

*/

import $ from "jquery";
// Add modern throttle and debounce functions to jQuery
(($) => {
  const debounce = (fn, wait, immediate = false) => {
    let timer;
    return function (...args) {
      const callNow = immediate && !timer;
      clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        if (!immediate) fn.apply(this, args);
      }, wait);
      if (callNow) fn.apply(this, args);
    };
  };

  const throttle = (fn, wait, options = {}) => {
    const { leading = true, trailing = true } = options;
    let last = 0,
      timer;
    return function (...args) {
      const now = performance.now();
      if (!last && !leading) last = now;
      const remaining = wait - (now - last);
      if (remaining <= 0 || remaining > wait) {
        if (timer) clearTimeout(timer);
        last = now;
        fn.apply(this, args);
      } else if (trailing && !timer) {
        timer = setTimeout(() => {
          last = leading ? performance.now() : 0;
          timer = null;
          fn.apply(this, args);
        }, remaining);
      }
    };
  };

  const withPreventDefault = (fn) =>
    function (event, ...args) {
      if (event && typeof event.preventDefault === "function") {
        event.preventDefault();
      }
      return fn.apply(this, [event, ...args]);
    };

  $.extend({ debounce, throttle, withPreventDefault });
})($);
globalThis.jQuery = $;
globalThis.$ = $;
